import React from "react"
import { useState } from "react"
import { Card, Container, Row, Col, Button, Form, Alert } from "react-bootstrap"
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaComments,
  FaPaperPlane,
  FaPhoneAlt,
  FaCalendarAlt,
  FaHeadphones,
  FaFacebook,
  FaWhatsapp,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa"
import Footer from "./Footer"

export default function ContactPage() {
  const [showAlert, setShowAlert] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    urgency: "",
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    setShowAlert(true)
    setTimeout(() => setShowAlert(false), 5000)
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
      urgency: "",
    })
  }

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  return (
    <div className="min-vh-100 overflow-hidden">
      {/* Hero Section */}
      <section
        className="position-relative overflow-hidden py-5"
        style={{
          background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
          minHeight: "60vh",
        }}
      >
        {/* Animated Background Elements */}
        {/* <div className="position-absolute w-100 h-100">
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "200px",
              height: "200px",
              background: "white",
              top: "20%",
              right: "15%",
              animation: "float 6s ease-in-out infinite",
            }}
          ></div>
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "150px",
              height: "150px",
              background: "white",
              bottom: "25%",
              left: "10%",
              animation: "float 8s ease-in-out infinite reverse",
            }}
          ></div>
        </div> */}

        <Container className="position-relative">
          <div className="text-center text-white py-5">
            <div
              className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <FaHeadphones className="me-2" />
              <span className="fw-medium">Get In Touch</span>
            </div>

            <h1 className="display-3 fw-bold mb-4">Contact Aidify</h1>
            <p className="fs-5 opacity-90" style={{ maxWidth: "700px", margin: "0 auto", lineHeight: "1.6" }}>
              Get in touch with us for immediate medical assistance or general inquiries. We're here to help you 24/7.
            </p>
          </div>
        </Container>
      </section>

      {/* Emergency Contact Banner */}
      <section
        className="py-4"
        style={{
          background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
        }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md={8}>
              <div className="d-flex align-items-center text-white">
                {/* <div
                  className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    animation: "pulse 2s infinite",
                  }}
                >
                  <FaPhoneAlt size={24} />
                </div> */}
                <div>
                  <h3 className="h5 fw-bold mb-1">Medical Emergency?</h3>
                  <p className="mb-0 opacity-90">Call us immediately for urgent medical assistance</p>
                </div>
              </div>
            </Col>
            <Col md={4} className="text-end">
              <a href="tel:+923001243439">
              <Button
                size="lg"
                variant="light"
                className="px-4 py-2 rounded-pill fw-bold"
                style={{
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                }}
              >
                <FaPhone className="me-2" style={{ color: "#dc2626" }} />
                <span style={{ color: "#dc2626" }}> +92 300 1243439</span>
              </Button>
              </a>
            </Col>
          </Row>
        </Container>
      </section>

      {showAlert && (
        <Container className="mt-4">
          <Alert
            variant="success"
            className="border-0 rounded-4"
            style={{
              backgroundColor: "rgba(5, 150, 105, 0.1)",
              border: "1px solid rgba(5, 150, 105, 0.2)",
            }}
          >
            <div className="d-flex align-items-center">
              <div
                className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                style={{
                  width: "40px",
                  height: "40px",
                  background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                }}
              >
                <FaPaperPlane className="text-white" size={16} />
              </div>
              <div>
                <strong style={{ color: "#059669" }}>Message Sent!</strong>
                <div style={{ color: "#059669" }}>We'll get back to you within 24 hours.</div>
              </div>
            </div>
          </Alert>
        </Container>
      )}

      <Container className="py-5">
        <Row className="g-5">
          {/* Contact Form */}
          <Col lg={8}>
            <Card
              className="border-0 rounded-4"
              style={{
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#f0fdfa",
              }}
            >
              <Card.Header
                className="border-0 rounded-top-4 p-4"
                style={{
                  background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                }}
              >
                <Card.Title className="text-white mb-1 h4 fw-bold">Send us a Message</Card.Title>
                <Card.Text className="text-white opacity-90 mb-0">
                  Fill out the form below and we'll get back to you as soon as possible
                </Card.Text>
              </Card.Header>
              <Card.Body className="p-5">
                <Form onSubmit={handleSubmit}>
                  <Row className="g-4">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-medium mb-2">Full Name *</Form.Label>
                        <Form.Control
                          type="text"
                          value={formData.name}
                          onChange={(e) => handleInputChange("name", e.target.value)}
                          className="border-0 rounded-3 py-3"
                          style={{
                            backgroundColor: "#ecfdf5",
                            transition: "all 0.3s ease",
                          }}
                          required
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#d1fae5"
                            e.target.style.boxShadow = "0 0 0 3px rgba(8, 145, 178, 0.1)"
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "#ecfdf5"
                            e.target.style.boxShadow = "none"
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-medium mb-2">Email Address *</Form.Label>
                        <Form.Control
                          type="email"
                          value={formData.email}
                          onChange={(e) => handleInputChange("email", e.target.value)}
                          className="border-0 rounded-3 py-3"
                          style={{
                            backgroundColor: "#ecfdf5",
                            transition: "all 0.3s ease",
                          }}
                          required
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#d1fae5"
                            e.target.style.boxShadow = "0 0 0 3px rgba(8, 145, 178, 0.1)"
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "#ecfdf5"
                            e.target.style.boxShadow = "none"
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-4 mt-2">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-medium mb-2">Phone Number</Form.Label>
                        <Form.Control
                          type="tel"
                          value={formData.phone}
                          onChange={(e) => handleInputChange("phone", e.target.value)}
                          className="border-0 rounded-3 py-3"
                          style={{
                            backgroundColor: "#ecfdf5",
                            transition: "all 0.3s ease",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#d1fae5"
                            e.target.style.boxShadow = "0 0 0 3px rgba(8, 145, 178, 0.1)"
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "#ecfdf5"
                            e.target.style.boxShadow = "none"
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-medium mb-2">Urgency Level</Form.Label>
                        <Form.Select
                          value={formData.urgency}
                          onChange={(e) => handleInputChange("urgency", e.target.value)}
                          className="border-0 rounded-3 py-3"
                          style={{
                            backgroundColor: "#ecfdf5",
                            transition: "all 0.3s ease",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#d1fae5"
                            e.target.style.boxShadow = "0 0 0 3px rgba(8, 145, 178, 0.1)"
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "#ecfdf5"
                            e.target.style.boxShadow = "none"
                          }}
                        >
                          <option value="">Select urgency</option>
                          <option value="low">Low - General Inquiry</option>
                          <option value="medium">Medium - Need Appointment</option>
                          <option value="high">High - Urgent Medical Need</option>
                          <option value="emergency">Emergency - Immediate Attention</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mt-4">
                    <Form.Label className="fw-medium mb-2">Subject *</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.subject}
                      onChange={(e) => handleInputChange("subject", e.target.value)}
                      className="border-0 rounded-3 py-3"
                      style={{
                        backgroundColor: "#ecfdf5",
                        transition: "all 0.3s ease",
                      }}
                      required
                      onFocus={(e) => {
                        e.target.style.backgroundColor = "#d1fae5"
                        e.target.style.boxShadow = "0 0 0 3px rgba(8, 145, 178, 0.1)"
                      }}
                      onBlur={(e) => {
                        e.target.style.backgroundColor = "#ecfdf5"
                        e.target.style.boxShadow = "none"
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mt-4">
                    <Form.Label className="fw-medium mb-2">Message *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      value={formData.message}
                      onChange={(e) => handleInputChange("message", e.target.value)}
                      placeholder="Please describe your medical needs or inquiry in detail..."
                      className="border-0 rounded-3"
                      style={{
                        backgroundColor: "#ecfdf5",
                        transition: "all 0.3s ease",
                      }}
                      required
                      onFocus={(e) => {
                        e.target.style.backgroundColor = "#d1fae5"
                        e.target.style.boxShadow = "0 0 0 3px rgba(8, 145, 178, 0.1)"
                      }}
                      onBlur={(e) => {
                        e.target.style.backgroundColor = "#ecfdf5"
                        e.target.style.boxShadow = "none"
                      }}
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    size="lg"
                    className="w-100 mt-4 py-3 rounded-3 fw-bold border-0"
                    style={{
                      background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                      boxShadow: "0 8px 25px rgba(8, 145, 178, 0.4)",
                      transform: "translateY(0)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)"
                      e.target.style.boxShadow = "0 12px 35px rgba(8, 145, 178, 0.5)"
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)"
                      e.target.style.boxShadow = "0 8px 25px rgba(8, 145, 178, 0.4)"
                    }}
                  >
                    <FaPaperPlane className="me-2" />
                    Send Message
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          {/* Contact Information */}
          <Col lg={4}>
            <div className="d-flex flex-column gap-4">
              {/* Primary Contact */}
              <Card
                className="border-0 rounded-4 text-center"
                style={{
                  background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                  boxShadow: "0 20px 60px rgba(8, 145, 178, 0.3)",
                }}
              >
                <Card.Body className="p-5 text-white">
                  <div
                    className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                    style={{
                      width: "80px",
                      height: "80px",
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      backdropFilter: "blur(20px)",
                    }}
                  >
                    <FaPhone size={32} />
                  </div>
                  <Card.Title className="h4 fw-bold mb-2">Primary Contact</Card.Title>
                  {/* <a href="tel:+923001243439"> */}
                  <div className="display-6 fw-bold mb-3">+92 300 1243439</div>
                  {/* </a> */}
                  <p className="mb-4 opacity-90">24/7 Medical Booking Hotline</p>
                
                 <a href="tel:+923001243439">  
                  <Button
                    variant="light"
                    className="px-4 py-2 rounded-pill fw-bold"
                    style={{
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                    }}
                  >
                    <FaPhoneAlt className="me-2" style={{ color: "#0891b2" }} />
                    <span style={{ color: "#0891b2" }}>Call Now</span>
                  </Button>
                  </a>
                </Card.Body>
              </Card>

              {/* Other Contact Methods */}
              {[
                {
                  icon: FaEnvelope,
                  title: "Email Support",
                  info: "support@aidify.pk",
                  detail: "Response within 24 hours",
                  gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                },
                {
                  icon: FaComments,
                  title: "Live Chat",
                  info: "Available on our website",
                  detail: "Mon-Fri, 8 AM - 8 PM",
                  gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                },
                {
                  icon: FaMapMarkerAlt,
                  title: "Office Address",
                  info: "584-Street 2",
                  detail: "Wapda Town, Lahore, Pakistan",
                  gradient: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                },
              ].map((contact, index) => (
                <Card
                  key={index}
                  className="border-0 rounded-4"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                    transform: "translateY(0)",
                    transition: "all 0.3s ease",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)"
                    e.currentTarget.style.boxShadow = "0 15px 50px rgba(0, 0, 0, 0.12)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.08)"
                  }}
                >
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center">
                      <div
                        className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: contact.gradient,
                          boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        <contact.icon size={20} className="text-white" />
                      </div>
                      <div>
                        <h6 className="fw-bold mb-1" style={{ color: "#1f2937" }}>
                          {contact.title}
                        </h6>
                        <p className="text-muted mb-1">{contact.info}</p>
                        <small className="text-muted">{contact.detail}</small>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ))}

              {/* Business Hours */}
              {/* <Card
                className="border-0 rounded-4"
                style={{
                  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                  backgroundColor: "#f0fdfa",
                }}
              >
                <Card.Header
                  className="border-0 rounded-top-4 p-4"
                  style={{
                    background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                  }}
                >
                  <Card.Title className="text-white mb-0 d-flex align-items-center h5 fw-bold">
                    <FaClock className="me-2" />
                    Service Hours
                  </Card.Title>
                </Card.Header>
                <Card.Body className="p-4">
                  {[
                    { service: "Phone Support:", hours: "24/7" },
                    { service: "Live Chat:", hours: "8 AM - 8 PM" },
                    { service: "Email Support:", hours: "24/7" },
                    { service: "Office Visits:", hours: "By Appointment" },
                  ].map((item, index) => (
                    <div key={index} className="d-flex justify-content-between mb-3">
                      <span className="text-muted">{item.service}</span>
                      <span className="fw-bold" style={{ color: "#0891b2" }}>
                        {item.hours}
                      </span>
                    </div>
                  ))}
                </Card.Body>
              </Card>

              {/* Quick Actions *
              <Card
                className="border-0 rounded-4"
                style={{
                  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                  backgroundColor: "#f0fdfa",
                }}
              >
                <Card.Header
                  className="border-0 rounded-top-4 p-4"
                  style={{
                    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  }}
                >
                  <Card.Title className="text-white mb-0 h5 fw-bold">Quick Actions</Card.Title>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="d-grid gap-3">
                    {[
                      {
                        icon: FaCalendarAlt,
                        text: "Schedule Appointment",
                        gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                      },
                      {
                        icon: FaComments,
                        text: "Start Live Chat",
                        gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                      },
                      {
                        icon: FaEnvelope,
                        text: "Email Support",
                        gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                      },
                    ].map((action, index) => (
                      <Button
                        key={index}
                        className="py-2 rounded-3 fw-medium border-0"
                        style={{
                          background: action.gradient,
                          transition: "all 0.3s ease",
                          transform: "translateY(0)",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-2px)"
                          e.target.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.3)"
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)"
                          e.target.style.boxShadow = "none"
                        }}
                      >
                        <action.icon className="me-2" />
                        {action.text}
                      </Button>
                    ))}
                  </div>
                </Card.Body>
              </Card> */}
            </div>
          </Col>
        </Row>

        {/* Map Section */}
        {/* <div className="mt-5">
          <Card
            className="border-0 rounded-4"
            style={{
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#f0fdfa",
            }}
          >
            <Card.Header
              className="border-0 rounded-top-4 p-4"
              style={{
                background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
              }}
            >
              <Card.Title className="text-white mb-1 h4 fw-bold">Find Our Office</Card.Title>
              <Card.Text className="text-white opacity-90 mb-0">
                Visit us at our main office in the Medical District
              </Card.Text>
            </Card.Header>
            <Card.Body className="p-0">
              <div
                className="rounded-bottom-4 d-flex align-items-center justify-content-center text-center text-muted"
                style={{
                  height: "300px",
                  background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)",
                }}
              >
                <div>
                  <div
                    className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: "80px",
                      height: "80px",
                      background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                      boxShadow: "0 10px 30px rgba(8, 145, 178, 0.3)",
                    }}
                  >
                    <FaMapMarkerAlt size={32} className="text-white" />
                  </div>
                  <p className="mb-1 fw-medium">Interactive Map</p>
                  <small>123 Aidify Plaza, Medical District, NY 10001</small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div> */}
      </Container>

       <Footer/>

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
          }
        }
      `}</style>
    </div>
  )
}
